import { capitalize } from 'vue';

import Validatable from '@/validator/Validatable';
import i18n from '@/vueI18n';

export interface IUnitDimensionAPI {
  dimensions: number[];
  status: string;
  unit_ids?: number[];
}
export default class UnitDimension extends Validatable {
  width: number;

  height: number;

  status: string;

  unitIDs?: number[];

  maxSize: number;

  constructor(width: number, height: number, status = 'BAD', unitIDs: number[] | null = null, maxSize = 6.4) {
    super();
    this.width = width;
    this.height = height;
    this.status = status;
    this.unitIDs = unitIDs;
    this.maxSize = maxSize;
  }

  get key(): string {
    return `${this.name}-${this.status}`;
  }

  get name(): string {
    return `${this.width} x ${this.height}`;
  }

  get aspectRatio(): number {
    return this.width / this.height;
  }

  get style(): string {
    let w: string;
    let h: string;
    if (this.aspectRatio > 1) {
      w = `${this.maxSize}rem`;
      h = `${(this.height / this.width) * this.maxSize}rem`;
    } else {
      h = `${this.maxSize}rem`;
      w = `${(this.width / this.height) * this.maxSize}rem`;
    }
    return `width: ${w}; height: ${h};`;
  }

  get classNames(): string {
    if (this.status === 'BAD') {
      return 'bad';
    }
    if (this.status === 'GOOD') {
      return 'good';
    }
    if (this.status === 'PERFECT') {
      return 'perfect';
    }
    if (this.status === 'INFO') {
      return 'info';
    }
    return '';
  }

  get statusName(): string {
    if (this.status === 'BAD') {
      return capitalize(i18n.global.t('messages.noCreativeFilesMatchingScreenSizes'));
    }
    if (this.status === 'GOOD') {
      return capitalize(i18n.global.t('messages.atLeastOneCreativeFileCloseEnoughToBePlayed'));
    }
    if (this.status === 'PERFECT') {
      return capitalize(i18n.global.t('messages.atLeastOneCreativeFilePerfectlyMatchesTheScreenSizes'));
    }
    return '';
  }

  get statusDescription(): string {
    if (this.status === 'BAD') {
      return capitalize(i18n.global.t('messages.creativeMissingDescription'));
    }
    if (this.status === 'GOOD') {
      return capitalize(i18n.global.t('messages.creativeGoodDescription'));
    }
    if (this.status === 'PERFECT') {
      return capitalize(i18n.global.t('messages.creativePerfectDescription'));
    }
    return '';
  }

  static fromApi(apiObject: IUnitDimensionAPI): UnitDimension {
    if (apiObject.unit_ids != null) {
      return new UnitDimension(apiObject.dimensions[0], apiObject.dimensions[1], apiObject.status, apiObject.unit_ids);
    }
    return new UnitDimension(apiObject.dimensions[0], apiObject.dimensions[1]);
  }

  toApi(): IUnitDimensionAPI {
    return {
      dimensions: [this.width, this.height],
      status: this.status,
      unit_ids: this.unitIDs,
    };
  }

  static fromObject(obj): UnitDimension {
    return super.fromObject(obj, new UnitDimension(obj.width, obj.height, obj.status, obj.unitIDs, obj.maxSize));
  }
}
